export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(qualification => qualification.id == id),
    loading: state => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, qualifications) {
      state.all = qualifications.sort((a, b) => {
        // Alphanumeric sort by Name
        const nameA = a.specialization.toUpperCase() // ignore upper and lowercase
        const nameB = b.specialization.toUpperCase() // ignore upper and lowercase

        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0
      })
      state.loading = false
    },
    set(state, qualification) {
      state.all = state.all.filter(o => o.id != qualification.id)
      state.all.push(qualification)
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('qualifications')
        .then(response => commit('setAll', response.data), response => commit('stopLoading'))
    },
    fetch({ commit }, id) {
      return Vue.$http.get(`qualifications/${id}`).then(response => commit('set', response.data))
    }
  }
}
